<template>
	<section class="footer-modal">
		<div class="footer-container">
			<v-btn
				v-if="!hidden"
				type="button"
				@click="cancelModal"
				color="error"
				class="btn-action mr-1">
				{{ cancelText }}
			</v-btn>
			<v-btn
				v-if="!hiddenSaveBtn"
				type="button"
				:color="successColor"
				@click="setInfo"
				class="btn-action ml-1"
				:disabled="isLoading">
				{{ successText }}
			</v-btn>
		</div>
	</section>
</template>

<script>

function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

export default {
	name: 'modal-sidebar-button',
	methods: {
		cancelModal,
		setInfo,
	},
	props: {
		isLoading: {
			default: false,
			type: Boolean,
		},
		hidden: {
			type: Boolean,
			default: false,
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false,
		},
		successColor: {
			default: 'success',
			type: String,
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String,
		},
		successText: {
			default: 'Aceptar',
			type: String,
		},
		cancelText: {
			default: 'Cancelar',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.footer-modal {
	height: 9vh;
	width: 100%;

	.footer-container {
		@include flex-center;
		height: 100%;

		.v-btn {
			border-radius: 5px;
			color: map-get($colors, white) !important;
			height: 30px;
			width: 97px;
		}

		.cancel {
			background-color: map-get($colors, error);
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/shared/utils/modal-sidebar-button.vue